// 184: shared sensor config for every touch-capable drag surface (team builder,
// calendar event-drag, event scheduler grid).
//
// MouseSensor (distance) -- on desktop a drag starts after an 8px move, and a
// plain click without movement still fires onClick (so tap-to-select / tap
// actions keep working on the same elements).
//
// TouchSensor (delay) -- on a phone a short long-press (200ms) starts the drag,
// while a quick swipe still scrolls the container. This is dnd-kit's recommended
// pattern for draggables that live INSIDE a scrollable list/grid: because the
// delay distinguishes a scroll gesture from a drag, we do NOT set
// `touch-action: none` on the items, so the pool / grid / calendar stay
// scrollable on touch. The unified PointerSensor cannot do this (a delay would
// also slow the mouse, and touch-action:none would kill scrolling).
import { MouseSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core";

export function useDndSensors() {
  return useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: 8 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 200, tolerance: 8 } }),
  );
}
